import { Grid } from '@mui/material';

import { US_STATE_OPTIONS } from '../../../../../../../constants';
import { FormAutocompleteField, FormTextField } from '../../../../../../common';

import type { InsuranceMemberFieldsProps } from './types';

export default function InsuranceMemberFields({
  formik,
  disabled,
  saveFieldOnBlur,
  handleAddressFieldChange,
  saveAddressFieldOnChange,
}: InsuranceMemberFieldsProps) {
  return (
    <>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Member first name"
          name="member_first_name"
          onBlur={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Member last name"
          name="member_last_name"
          onBlur={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Member street address line one"
          name="member_street_address_line_one"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Member address line two (Apartment/unit)"
          name="member_street_address_line_two"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Member city"
          name="member_street_address_city"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Member state"
          name="member_street_address_state"
          onChange={saveAddressFieldOnChange}
          options={US_STATE_OPTIONS}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Member zip code"
          name="member_street_address_zip"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
          required
        />
      </Grid>
    </>
  );
}
